import React, { useState, useEffect, useContext } from "react";
import { auth, db } from "../../firebase/firebaseConfig";
import { onSnapshot, collection, query, where } from "firebase/firestore";
import Header from "../../elements/Header";
import { UserContext } from "../../context/UserContext";
import moment from "moment";
import { EnvContext } from "../../context/EnvContext";
import config from "../../config";
import Footer from "../../elements/Footer";
import FAQ from "../../elements/FAQ";

import {
  ArrowDropDownOutlined,
  ArrowDropUpOutlined,
} from "@mui/icons-material";

export const OrderHistory = ({}) => {
  //
  const environment = useContext(EnvContext);
  //
  const { user } = useContext(UserContext);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedOrder, setExpandedOrder] = useState(null);

  // environment
  const collectionPath =
    environment === "staging"
      ? config.environment.staging.collectionPath
      : config.environment.production.collectionPath;

  useEffect(() => {
    if (user) {
      const q = query(
        collection(db, `${collectionPath}Orders/OrdersList/DataBase`),
        where("user_id", "==", user.uid),
      );
      const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
          const fetchedOrders = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          setOrders(fetchedOrders);
          setLoading(false);
        },
        (error) => {
          console.error("Error fetching orders: ", error);
          setLoading(false);
        },
      );

      return () => unsubscribe();
    }
  }, [user]);

  const toggleOrderDetails = (orderId) => {
    setExpandedOrder(expandedOrder === orderId ? null : orderId);
  };

  const renderOrderSection = (
    title,
    description,
    noOrdersMessage,
    filteredOrders,
  ) => (
    <div style={{ ...styles.sectionContainer, padding: "0px 10px" }}>
      <div style={{ height: 20 }} />
      <div
        style={{ fontWeight: 600, fontSize: "1rem", padding: "0px 0 10px 5px" }}
      >
        {title}
      </div>
      {description && (
        <div
          style={{
            ...styles.content,
            padding: "0px 0 20px 0px",
            color: "gray",
          }}
        >
          {description}
        </div>
      )}
      <div style={styles.content}>
        {filteredOrders.length === 0 && (
          <div
            style={{ color: "gray", fontSize: ".8rem", padding: "0px 10px" }}
          >
            {noOrdersMessage}
          </div>
        )}
        {filteredOrders.map((order, index) => {
          let total_price = 0;
          total_price = order.items
            .reduce(
              (total, item) =>
                total + (item?.price?.finalPrice || 0) * (item.quantity || 0),
              0,
            )
            .toFixed(2);
          if (order?.shippingCost) {
            total_price = (
              parseFloat(total_price) + parseFloat(order.shippingCost / 100)
            ).toFixed(2);
          }

          let orderStatus = "";
          switch (order?.status) {
            case "PAID":
              orderStatus = "Preparing";
              break;
            case "in_progress":
              orderStatus = "Preparing";
              break;
            case "pending":
              orderStatus = "Pending";
              break;
            case "complete":
              orderStatus = "Complete";
              break;
            case "shipped":
              orderStatus = "Shipped";
              break;
            case "delivered":
              orderStatus = "Delivered";
              break;
            case "canceled":
              orderStatus = "Canceled";
              break;
            case "returned":
              orderStatus = "Returned";
              break;
            case "reviewing":
              orderStatus = "Reviewing";
              break;
            default:
              orderStatus = "Pending";
          }

          return (
            <div key={order.id} style={{ ...styles.orderCard }}>
              <div style={{ ...styles.orderCardHeader, display: "flex" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#D9D9D9",
                    borderRadius: 4,
                    flex: 1.5,
                  }}
                >
                  {(() => {
                    const firstItem = order?.items?.[0];
                    const imageSrc =
                      firstItem &&
                      firstItem.images &&
                      firstItem.images.length > 0
                        ? firstItem.images[0]
                        : "/images/no_product_image.png";
                    const imageAlt =
                      firstItem && firstItem.product_name
                        ? firstItem.product_name
                        : "No product image";
                    return (
                      <img
                        src={imageSrc}
                        alt={imageAlt}
                        style={{ ...styles.productImage }}
                      />
                    );
                  })()}
                </div>
                <div style={{ flex: 2, paddingLeft: 5 }}>
                  <div style={styles.orderHeader}>
                    <h3 style={styles.productName}>
                      {order?.items[0].product_name}
                    </h3>
                  </div>

                  <div style={{ ...styles.orderInfo }}>
                    Order Id:{" "}
                    {order?.sooperstock_order_id
                      ? order.sooperstock_order_id.split("-")[0]
                      : "N/A"}{" "}
                    | Items: {order.items.length || 0}
                  </div>
                  <div style={{ ...styles.orderInfo }}>
                    Status: {orderStatus}
                  </div>
                  <div style={{ ...styles.orderInfo }}>
                    Placed on:{" "}
                    {moment(
                      order?.created_at && order?.created_at.toDate(),
                    ).format("YYYY-MM-DD")}
                  </div>
                  <div style={{ ...styles.orderInfo, color: "black" }}>
                    <span style={{ marginLeft: 0 }}>
                      Order total: ${total_price}
                    </span>
                  </div>
                  {order?.items.length > 1 && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                      }}
                    >
                      <div
                        style={styles.orderLink}
                        onClick={() => toggleOrderDetails(order.id)}
                      >
                        {order?.items.length > 0 ? (
                          expandedOrder === order.id ? (
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              Hide Details <ArrowDropUpOutlined />
                            </div>
                          ) : (
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              Show Details <ArrowDropDownOutlined />
                            </div>
                          )
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div style={{ display: "flex" }} />
              {expandedOrder === order.id && (
                <div
                  style={{
                    ...styles.orderItems,
                    borderTop: "1px solid #ccc",
                    paddingTop: 10,
                  }}
                >
                  {order.items.length > 1 &&
                    order.items.map((item, index) => (
                      <div key={item.id} style={styles.itemDetails}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#D9D9D9",
                            borderRadius: 4,
                            flex: 1.5,
                          }}
                        >
                          <img
                            src={
                              order?.items?.[index]?.images?.[0]?.length > 1
                                ? order?.items[index]?.images[0]
                                : "/images/no_product_image.png"
                            }
                            alt={
                              order?.items?.[0]?.product_name ||
                              "No product image"
                            }
                            style={{ ...styles.productImage }}
                          />
                        </div>
                        <div style={{ flex: 2, paddingLeft: 5 }}>
                          <div style={styles.orderHeader}>
                            <h3 style={styles.productName}>
                              {item?.product_name}
                            </h3>
                          </div>

                          <div style={{ ...styles.orderInfo }}>
                            Qty: {item?.quantity || 0}
                          </div>
                          <div style={{ ...styles.orderInfo, color: "black" }}>
                            <span style={{ marginLeft: 0 }}>
                              Total: ${item?.price?.finalPrice}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  {order?.shippingCost > 0 && (
                    <div
                      style={{
                        ...styles.itemDetails,
                        borderTop: "1px solid #ccc",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flex: 1.5,
                        }}
                      ></div>
                      <div
                        style={{ ...styles.orderInfo, flex: 2, paddingLeft: 5 }}
                      >
                        Shipping:{" "}
                        <span style={{ fontWeight: 600 }}>
                          ${parseFloat(order.shippingCost / 100).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          height: "100vh",
          width: "100vw",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        Loading...
      </div>
    );
  }

  const currentOrders = orders.filter((order) => order.status !== "complete");
  const pastOrders = orders.filter((order) => order.status === "complete");

  return (
    <div style={styles.container}>
      <Header search={false} />

      <div
        style={{
          height: 35,
          borderBottom: "1px solid black",
          marginBottom: 20,
        }}
      />
      <div
        css={{
          maxWidth: "1140px",
          margin: "0 auto",
        }}
      >
        <div style={{ ...styles.title, padding: "0px 15px" }}>Orders</div>
        {renderOrderSection(
          "Current orders",
          "",
          "Your current orders will show up here.",
          currentOrders,
        )}
        {renderOrderSection(
          "Past orders",
          "",
          "Your order history shows up here.",
          pastOrders,
        )}
        <div style={{ height: 50 }} />
        <FAQ />
      </div>
      <Footer />
    </div>
  );
};

const styles = {
  container: {},
  content: {
    padding: "10px",
  },
  content: {
    padding: "0px 0",
    fontWeight: "500",
    fontSize: ".9rem",
  },
  sectionContainer: {
    marginTop: "20px",
  },
  title: {
    fontSize: "1.2rem",
    fontWeight: "600",
    marginBottom: 20,
  },
  orderCard: {
    border: "1px solid #ccc",
    padding: "3px",
    marginBottom: "10px",
    borderRadius: "4px",
    backgroundColor: "#fff",
  },
  orderCardHeader: {
    display: "flex",
    flex: 1,
  },
  productImage: {
    display: "flex",
    width: "90%",
    height: "auto",
    objectCover: "contain",
  },
  orderDetails: {
    flex: 1,
  },
  orderHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  productName: {
    fontSize: "1rem",
    fontWeight: "500",
    margin: 0,
    // max two lines
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
  orderLink: {
    display: "flex",
    fontSize: ".8rem",
    color: "black",
    cursor: "pointer",
    border: "1px solid black",
    padding: "0px 8px",
    borderRadius: "20px",
    height: 20,
  },
  orderInfo: {
    margin: "2px 0",
    color: "#666",
    fontSize: ".7rem",
  },
  price: {
    color: "black",
    fontWeight: "bold",
    marginLeft: "10px",
  },
  orderItems: {
    marginTop: "10px",
  },
  itemDetails: {
    display: "flex",
    marginBottom: "10px",
  },
  itemImage: {
    width: "40px",
    height: "60px",
    marginRight: "10px",
  },
};

export default OrderHistory;
